import { render, staticRenderFns } from "./DriverTransportReportModal.vue?vue&type=template&id=47dd207d&scoped=true"
import script from "./DriverTransportReportModal.vue?vue&type=script&lang=js"
export * from "./DriverTransportReportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dd207d",
  null
  
)

export default component.exports